import React from "react";
import { Col, Row } from "react-bootstrap";

const RowImgStory = (props) => {
  return (
    <Row xl={12} className={` row justify-content-center  `}>
      <Col className="col-12 text-center">
        <img
          id={props.id}
          className={`${props.classImg}`}
          src={`/assets/img/UsPage/${props.nameImg}`}
          alt={"IMG"}
        />
      </Col>
    </Row>
  );
};
export default RowImgStory;
